<template lang="html">
    <v-form ref="form" v-model="isValid">
        <v-container grid-list-xs>
            <v-layout wrap>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs12>
                            <v-select
                              :items="projects"
                              v-model="project_id"
                              label="Projet"
                              item-text="label"
                              item-value="id"
                              autocomplete
                              autofocus
                              clearable
                              :loading="loading"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        data(){
            return {
                title: 'Modifier le projet',
                icon:     'folder',
                isValid:  false,
                projects: [],
                project_id: null,
                loading: false,
            }
        },
        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },
            onValidate(){
                if(this.$refs.form.validate()){
                    this.axios.put(`/api/products/${this.$store.state.single.data.id}`, {project_id: this.project_id})
                    .then(response => {
                        this.$store.dispatch('updateSingleData', { key:'project_id', value:this.project_id })
                        this.$store.dispatch('updateSingleData', { key:'project', value: this.$_.find(this.projects,p => p.id == this.project_id)})
                        this.onClose()
                    })
                } else {
                    this.onClose()
                }
            },
            getProjects() {
                this.axios.get(`/api/projects`)
                .then(response => {
                    this.projects = response.data
                    if(this.$store.state.single.data.project_id != null) {
                        this.project_id = this.$store.state.single.data.project_id
                    }
                    this.loading = false
                })
            }
        },
        mounted() {
            this.loading=true
            this.getProjects()
        },
    }
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/views/products/single/UpdateProject.vue